import createLucideIcon from '../createLucideIcon';

const Trash2 = createLucideIcon('Trash2Icon', [
  ['path', { d: 'M3 6h18', key: 'd0wm0j' }],
  ['path', { d: 'M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6', key: '4alrt4' }],
  ['path', { d: 'M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2', key: 'v07s0e' }],
  ['line', { x1: '10', y1: '11', x2: '10', y2: '17', key: 'm9v7hp' }],
  ['line', { x1: '14', y1: '11', x2: '14', y2: '17', key: '23cpt9' }],
]);

export default Trash2;
